import { render, staticRenderFns } from "./GamesView.vue?vue&type=template&id=59e55160"
import script from "./GamesView.vue?vue&type=script&lang=js"
export * from "./GamesView.vue?vue&type=script&lang=js"
import style0 from "./scss/styles.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports